<template>
  <div class="container">
    <div class="user">
      <div class="face">
        <span>
          <img :src="userInfo.headimgurl" alt=""></img>
        </span>
      </div>
      <div class="info">
        <div class="name">{{ userInfo.nickname || '-' }}</div>
        <div class="level">等级：{{ userInfo.level_msg || '-' }}</div>
        <div class="score">积分：<span>{{ userInfo.score || '-' }}</span></div>
      </div>
    </div>
    <div class="log">
      <div class="log-item" v-for="item in result">
        <div class="timer">{{ item.gift_time }}</div>

        <div class="tips" v-if="item.gift_prize == 0">阳光普照100积分</div>
        <div class="tips" v-else-if="item.gift_type == 2">抽奖200积分</div>
        <div class="tips" v-else-if="item.gift_type == 4">抽奖100积分</div>
        <div class="tips" v-else-if="item.gift_type == 6">抽奖50积分</div>

        <div class="btn">
          <span v-if="item.gift_state == 0" @click="handleScore(item)">领取</span>
          <span v-else class="active">已领</span>
        </div>
      </div>
    </div>
    <div v-if="uid == 1">{{  userInfo  }}----{{ uid }}</div>
  </div>
</template>

<script>

import { getUserInfo } from "network/profile";
import { event_qb321_add_score, gift, setUserGift } from "network/home"
export default {
  data() {
    return {
      userInfo: {},
      uid: '',
      result: [],
    };
  },
  computed: {
  },
  created() {
    this.uid = this.$route.query.uid;
    // 用户信息
    this.getUser();
    // 获取记录
    this.getGift()
  },
  activated() {
  },
  mounted() {},
  methods: {
    getUser() {
      //获取个人信息
      const from = this.$route.query.from;
      getUserInfo(from, this.$route.query.inviter_id).then((res) => {
        this.userInfo = res.data;
      });
    },
    handleScore(item) {
      let _score = 0;
      if (item.gift_type == 2) _score = 200
      if (item.gift_type == 4) _score = 100
      if (item.gift_type == 6) _score = 50
      if (item.gift_type == 9) _score = 100 //阳光普照

      this.$toast.loading({ message: '加载中...', forbidClick: true });
      event_qb321_add_score({
        user_id: this.userInfo.id,
        score: _score,
      }).then(res => {
        console.log(res)
        if (res && res.message_code && res.message_code == 'SUCCESS') {
          setUserGift({
            gift_id: item.gift_id,
            uid: this.uid,
            club_id: this.userInfo.id,
          }).then(r => {
            // 更新用户信息
            this.getUser();
            // 更新记录
            this.getGift()

            this.$toast.clear()
            this.$dialog.alert({
              title: '提示',
              message: '领取成功',
            }).then(() => {
            });
          })
          
        }
        else {
          this.$toast("领取失败");
        }
      })
    },
    getGift() {
      gift({
        uid: this.uid || 1,
      }).then(res => {
        this.result = res.result;
      })
    },
  },
};
</script>

<style scoped>
  .container {
    width: 100%;
    height: 100vh;
    background-color: #FEF9E5;
  }
  .user {
    display: flex;
    width: 350px;
    margin: auto;
    padding-top: 35px;
  }
  .user .face {
    width: 74px;
    height: 74px;
  }
  .user .face span {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 74px;
    background-color: #eee;
    overflow: hidden;
  }
  .user .face span img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .user .info {
    padding-left: 10px;
    flex: 1;
  }
  .user .info .name {
    font-size: 16px;
    color: black;
  }
  .user .info .level {
    font-size: 14px;
    color: black;
    opacity: .5;
  }
  .user .info .score {
    font-size: 12px;
    color: #333;
  }
  .user .info .score span {
    font-size: 22px;
    color: black;
  }

  .log {
    padding-top: 20px;
    width: 350px;
    margin: auto;
  }
  .log .log-item {
    width: 100%;
    height: 60px;
    border-radius: 12px;
    background-color: white;
    margin-bottom: 1px;
    display: flex;
    justify-content: space-between;
    line-height: 60px;
  }
  .log .log-item .timer {
    padding-left: 10px;
    box-sizing: border-box;
    width: 160px;
    font-size: 12px;
    overflow: hidden; /* 隐藏超出部分的内容 */
    white-space: nowrap; /* 防止文本换行 */
    text-overflow: ellipsis; /* 显示省略号 (...) */
  }
  .log .log-item .tips {
    width: 120px;
    color: #DA122B;
    font-size: 12px;
    overflow: hidden; /* 隐藏超出部分的内容 */
    white-space: nowrap; /* 防止文本换行 */
    text-overflow: ellipsis; /* 显示省略号 (...) */
  }
  .log .log-item .btn {
    width: 70px;
    height: 100%;
    color: #DA122B;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .log .log-item .btn span {
    border: 1px solid #DA122B;
    box-sizing: border-box;
    width: 50px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    border-radius: 22px;
  }
  .log .log-item .btn span.active {
    opacity: .5;
  }
</style>